import { render } from "./physiotherapy_list.vue?vue&type=template&id=e8667a46&scoped=true"
import script from "./physiotherapy_list.vue?vue&type=script&lang=js"
export * from "./physiotherapy_list.vue?vue&type=script&lang=js"

import "./physiotherapy_list.vue?vue&type=style&index=0&id=e8667a46&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8667a46"]])

export default __exports__